// utils/rsa.js
import JSEncrypt from "jsencrypt";
import http from "../api/httpRequest";
import store from "../store";

let PUBLIC_KEY = "";

/**
 * 初始化：从后端获取 RSA 公钥
 */
export const initRsaPublicKey = () => {
  return new Promise((resolve, reject) => {
    http({
      url: "/pass/publicKey",
      method: "GET",
    })
      .then((res) => {
        if (res) {
          PUBLIC_KEY = res;
          store.commit("setPublicKey", PUBLIC_KEY);
          resolve(true);  // 公钥获取成功
        } else {
          console.error("获取公钥失败：", res);
          reject("获取公钥失败");
        }
      })
      .catch((err) => {
        console.error("公钥获取失败：", err);
        reject("公钥获取失败");
      });
  });
};

/**
 * RSA 加密密码
 */
export const rsaEncryptPassword = (password) => {
  if (!PUBLIC_KEY) {
    throw new Error("RSA 公钥未初始化，请先调用 initRsaPublicKey()");
  }

  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(PUBLIC_KEY);

  const encrypted = encryptor.encrypt(password);
  if (!encrypted) {
    throw new Error("密码加密失败");
  }
  return encrypted;
};
